export default __webpack_public_path__ + "static/imgAlloypng-64edf47b3dfdeb2761fb9f3c252dabf0.png";